import { useQuery } from '@tanstack/react-query';
import { orpc } from 'src/api/rpc/client';

// Poll every 10s when the 855 is still pending. Matches the backend's
// Orderful-refresh throttle (`ORDER_CONFIRMATION_855_REFRESH_INTERVAL_MS`)
// so the server actually re-fetches upstream state instead of returning
// a cached DB row. Sent / error / not_sent don't change without user
// action, so polling is off for those.
const PENDING_POLL_INTERVAL_MS = 10_000;

const useOrderConfirmation = (
  orderConfirmationId: string | null,
  enabled = true,
) => {
  return useQuery({
    ...(orderConfirmationId
      ? orpc.edi.orderConfirmations.get.queryOptions({
          input: { orderConfirmationId },
        })
      : { queryKey: ['order-confirmation', 'disabled'], queryFn: () => null }),
    enabled: enabled && !!orderConfirmationId,
    // Always fetch fresh when the modal opens — the list view's cached
    // row may be stale (sent-but-actually-failed is the bug we're fixing).
    refetchOnMount: 'always',
    refetchOnWindowFocus: true,
    refetchInterval: (query) =>
      query.state.data?.edi855Status === 'pending'
        ? PENDING_POLL_INTERVAL_MS
        : false,
  });
};

export default useOrderConfirmation;
